import type { ObjPathProxy } from "ts-object-path";
import type { MyPlannResourceDictionary } from "web_myplann/Infrastructure/Translations/ResourceDictionary";
import { Resources } from "web_myplann/Infrastructure/Translations/Resources";
import type { InspirationScenarioKey } from "web_myplann/Inspiration/Types/InspirationTypes";

export const INSPIRATION_SCENARIO_KEYS: InspirationScenarioKey[] = [
	"conservative",
	"balanced",
	"dynamic",
];

export const INSPIRATION_DEFAULT_SCENARIO: InspirationScenarioKey = "balanced";

export const INSPIRATION_SCENARIO_RATES: Record<
	InspirationScenarioKey,
	number
> = {
	conservative: 0.04,
	balanced: 0.06,
	dynamic: 0.08,
};

export const INSPIRATION_SCENARIO_LABELS: Record<
	InspirationScenarioKey,
	ObjPathProxy<MyPlannResourceDictionary, string>
> = {
	conservative: Resources.Inspiration.Scenarios.conservative,
	balanced: Resources.Inspiration.Scenarios.balanced,
	dynamic: Resources.Inspiration.Scenarios.dynamic,
};

export const INSPIRATION_MONTHLY_SLIDER_MAX_FLOOR = 80_000;
export const INSPIRATION_MONTHLY_SLIDER_MAX_CEILING = 200_000;
export const INSPIRATION_MONTHLY_SLIDER_MAX_ROUNDING = 10_000;
